// extracted by mini-css-extract-plugin
export default {"form":"SignUp_form__XHkEh","captchaContainer":"SignUp_captchaContainer__3WZfL"};